import { v4 as uuidv4 } from 'uuid';
import { UnsupportedValueError } from '../errors';
import { Float, Float64, Integer, Integer32, Integer64, ParameterDict, ParameterList, Primitive, Size2D, Timestamp, } from '../types';
import { isObject } from '../utils';
export function buildParameterValue(type, value) {
    switch (type) {
        case 'Boolean':
            if (typeof value === 'boolean')
                return value;
            break;
        case 'Bytes':
            if (value instanceof Uint8Array)
                return value;
            break;
        case 'Dict':
            if (isObject(value)) {
                return ParameterDict.new().addItems(Object.entries(value)).build();
            }
            break;
        case 'Float':
            if (typeof value === 'number')
                return new Float64(value);
            else if (value instanceof Float)
                return value;
            break;
        case 'Integer':
            if (typeof value === 'number')
                return new Integer32(value);
            else if (typeof value === 'bigint')
                return new Integer64(value);
            else if (value instanceof Integer)
                return value;
            break;
        case 'List':
            if (Array.isArray(value)) {
                const builder = ParameterList.new();
                value.forEach((entry) => builder.addValue(uuidv4(), entry));
                return builder.build();
            }
            break;
        case 'Size2D':
            if (value && isObject(value) && 'height' in value && 'width' in value) {
                return new Size2D(value.height, value.width);
            }
            break;
        case 'Text':
            if (typeof value === 'string')
                return value;
            break;
        case 'Timestamp':
            if (typeof value === 'string')
                return Timestamp.fromISOString(value);
            else if (value instanceof Date)
                return Timestamp.fromDate(value);
            else if (value instanceof Timestamp)
                return value;
            break;
        case 'URI':
            if (typeof value === 'string')
                return new URL(value);
            if (value instanceof URL)
                return value;
            break;
        default:
            if (value instanceof Primitive)
                return value;
    }
    throw new UnsupportedValueError(`Unsupported value for type ${type}`);
}
//# sourceMappingURL=data:application/json;base64,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